import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { Message } from '@models/system';
import { Account } from '@models/domain';

@Injectable({
    providedIn: 'root'
})
export class AccountService {

    constructor(private http: HttpClient) {}

    get() : Observable<HttpResponse<Account>> {
        return this.http.get<Account>(env.API_URL + '/account', {
            params: {},
            observe: 'response'
        });
    }

    put(t: Account): Observable<HttpResponse<Message>> { 
        return this.http.put<Message>(env.API_URL + '/account', t, {
            params: {},
            observe: 'response'
        });
    }
}
